import "./pages.css";

export const NotFound = () => {
    return(
        <div className="content">
            <h1>404</h1>
            <h3>Page not found</h3>
        </div>
    );
}